<template>
    <div class="template-manage-dialog">
        <el-dialog
            :visible="true"
            :title="isStandard ? '关联标准价格' : '关联非标准价格'"
            :width="isStandard ? '1200px' : '1000px'"
            v-loading="loading"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            @close="emit('handleClose', false)">
            <div class="template-search-add-box">
                <search-box
                    ref="searchBox"
                    :search-key="config.name"
                    :fields="config.searchFields"
                    @search-change="priceTemplateList.searchList"
                />
            </div>
            <table-box
                class="template-table"
                v-loading="priceTemplateList.tableLoading"
                ref="tableBox"
                :height="config.height"
                :columns="config.columns"
                :rows="priceTemplateList.totalData"
                :highlight-current-row="true"
                @current-change="handleCurrentChange"
                @row-dblclick="rowDBclick"
            >
            </table-box>
            <lots-pagination
                @size-change="priceTemplateList.sizeChange"
                :current-page.sync="priceTemplateList.pageNo"
                @current-change="priceTemplateList.pageChange"
                layout="total, sizes, prev, pager, next, jumper"
                :total="priceTemplateList.pageTotal"
            ></lots-pagination>
            <span slot="footer">
                <el-button type="primary" size="mini" @click="confirm">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { ref, reactive, computed, onMounted } from '@vue/composition-api';
import _ from 'lodash';
import searchBox from '@/components/lots/searchBox';
import tableBox from '@/components/lots/tableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { tableConfig, standardPriceTableConfig } from './config.js';
import { priceTemplate, standardPriceTemplate, getOrderType } from '@mdm/api/contractManage/priceApi.js';
import { CONTRACT_PRICE_TYPE } from '../mains/config.js';
import { Message } from 'element-ui';
import { dictWithUrl } from '@/components/lots/api';
export default {
    components: { searchBox, tableBox, lotsPagination },
    props: {
        detailData: {
            type: Object,
            default() {
                return {};
            }
        },
        loading: {
            type: Boolean,
            default: false
        },
        priceType: {
            type: [String, Number],
            default: '2'
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const emit = setupContext.emit;
        // 标准价格类型
        const standardPriceType = CONTRACT_PRICE_TYPE.STANDARD_PRICE_TYPE;
        // 非标准价格类型
        const nonStandardPriceType = CONTRACT_PRICE_TYPE.NORMAL_PRICE_TYPE;
        const isStandard = computed(() => String(props.priceType) === String(standardPriceType));
        const isNonStandard = computed(() => String(props.priceType) === String(nonStandardPriceType));
        const config = reactive(isStandard.value ? JSON.parse(JSON.stringify(standardPriceTableConfig)) : JSON.parse(JSON.stringify(tableConfig)));
        class DataDetailClass extends AdvanceListClass {
            beforeGetList(condition) {
                if (condition.businessType && condition.businessType.length) {
                    // 非标时 businessType 是字符串，标准时 businessTypeNameList 是数组（根据 businessType 映射 name）
                    if (isNonStandard.value) {
                        condition.businessType = String(condition.businessType);
                    } else {
                        // 标准时：遍历 businessType，用 businessTypeDictData 映射出 name 组成数组
                        condition.businessTypeNameList = condition.businessType.map(key => businessTypeDictData.value[key]).filter(Boolean);
                    }
                } else if (isNonStandard.value) {
                    // 非标时没选择返回空字符串
                    condition.businessType = String(props.detailData.businessType);
                } else {
                    // 标准时没选择返回空数组
                    condition.businessTypeNameList = [];
                }
                if (isNonStandard.value) {
                    condition.status = 1;
                }
                return condition;
            };
            afterGetList(res) {
                if (+res.code === 0 && res.data.list) {
                    if (isStandard.value) {
                        res.data.list.forEach(item => {
                            if (item.billingScenes && item.billingScenes.length) {
                                item.sceneName = item.billingScenes.map(scene => scene.sceneName).join(',');
                            }
                        });
                    }
                    this.totalData.value = res.data.list;
                    this.pageTotal.value = res.data.totalCount;
                }
            }
        };
        const priceTemplateList = new DataDetailClass({
            Api: {
                listApi: isStandard.value ? standardPriceTemplate : priceTemplate
            }
        });
        const businessTypeDictData = ref({});
        onMounted(async() => {
            priceTemplateList.getList();
            await dictWithUrl('SYS_BMS_BUSI_TYPE').then(res => {
                businessTypeDictData.value = res.data['SYS_BMS_BUSI_TYPE'];
            });
            getOrderType().then((res) => {
                if (res.code === '0' && res.data.list && res.data.list.length) {
                    config.searchFields.forEach((item) => {
                        if (item.value === 'orderTypeCode') {
                            // eslint-disable-next-line max-nested-callbacks
                            item.options = res.data.list.map(subItem => {
                                return {
                                    label: subItem.orderTypeName,
                                    value: subItem.orderTypeCode
                                };
                            });
                        }
                        if (item.value === 'businessType') {
                            item.options = [];
                            // eslint-disable-next-line max-nested-callbacks
                            props.detailData.businessType.length && props.detailData.businessType.forEach(key => {
                                const optionItem = {
                                    label: businessTypeDictData.value[key],
                                    value: key
                                };
                                item.options.push(optionItem);
                            });
                        }
                    });
                }
            });
        });
        const rowDBclick = (row) => {
            const {
                templateCode,
                templateName,
                feeName,
                description,
                businessTypeName,
                calculateType,
                collectUnitName,
                priceCols,
                calcRuleCode,
                feeCode,
                orderTypeCode,
                orderTypeName,
                priceTemplateUrl,
                priceCode,
                businessUnitCode
            } = row;
            emit('confirm', {
                templateCode,
                templateName,
                feeName,
                description,
                businessTypeName,
                calculateType,
                collectUnitName,
                priceCols,
                calcRuleCode,
                feeCode,
                orderTypeCode,
                orderTypeName,
                priceTemplateUrl,
                priceCode,
                businessUnitCode
            });
        };
        const confirm = () => {
            if (Object.keys(selectedRow.value).length === 0) {
                return Message.warning('请选择数据');
            }
            const {
                templateCode,
                templateName,
                feeName,
                description,
                businessTypeName,
                calculateType,
                collectUnitName,
                priceCols,
                calcRuleCode,
                feeCode,
                orderTypeCode,
                orderTypeName,
                priceTemplateUrl
            } = selectedRow.value;
            emit('confirm', {
                templateCode,
                templateName,
                feeName,
                description,
                businessTypeName,
                calculateType,
                collectUnitName,
                priceCols,
                calcRuleCode,
                feeCode,
                orderTypeCode,
                orderTypeName,
                priceTemplateUrl
            });
        };
        const selectedRow = ref({});
        const handleCurrentChange = (row) => {
            selectedRow.value = row;
        };
        return {
            emit,
            config,
            priceTemplateList,
            rowDBclick,
            selectedRow,
            handleCurrentChange,
            confirm,
            isStandard,
            isNonStandard
        };
    }
};
</script>
<style lang="less">
.template-manage-dialog {
    .template-search-add-box {
        display: flex;
        .model-table-search {
            flex: 2;
        }
        .add-btn {
            flex: 1;
            position: relative;
            left: -56px;
        }
    }
    .template-table {
        margin: 10px 0 5px 0;
    }
}
</style>
